import epic from 'bundles/epic/clients/__generated__/CopyTest';

// alias should at least include a single context
// e.g. source-pageName-fieldName-languageCode
type Alias = `${'web' | 'contentful'}-${string}`;
type EpicReturnValue = string | false | undefined | null;

export const COPY_TEST_EPIC_NAMESPACE = 'CopyTest';

// Design Doc: https://docs.google.com/document/d/1_wcv27qPIqmGavuoctmQjIsmpc88JLAUCE9XruKSEqo/

export function copyTest(alias: Alias, defaultString: string): string;
export function copyTest(alias: Alias, defaultString?: string): string | undefined;
export function copyTest(alias: Alias, defaultString: string | null | undefined): string | null | undefined; // looks the same but actually for Maybe<string> | undefined
export function copyTest(alias: Alias, defaultString: string | undefined | null): string | undefined | null {
  // @ts-expect-error because parameter is defined dynamically
  const epicReturnValue = epic.get(alias) as EpicReturnValue;

  // edge case: 'false' as string instead of boolean
  const isFalseString = typeof epicReturnValue === 'string' && epicReturnValue?.toLowerCase() === 'false';
  if (isFalseString) return defaultString;

  if (epicReturnValue) return epicReturnValue;

  return defaultString;
}

// use if intentionally only want impression when string exist
export function copyTestWithCheck(alias: Alias, defaultString?: string | null): string | null | undefined {
  if (!defaultString) return defaultString;
  return copyTest(alias, defaultString);
}
